// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9c782ea0","387":"857c89f3","409":"84427eb9","436":"53c94547","453":"e1ed1f42","598":"c57348b2","678":"51e0b472","866":"19de79a6","879":"e3d74162","896":"1989d72e","951":"2aa0dc0c","967":"aee96f9d"}[chunkId] + ".chunk.js";
};